import { useContext } from 'react'
import PropTypes from 'prop-types'
import { Checkbox, Text } from '@leroy-merlin-br/backyard-react-ui'

import * as S from './styled'
import { buildPath } from '../../../../utils/buildUrl'
import { EntryKeyContext } from '../../../../context'

const buildFilterPath = (name, value, url, filtersQuery, isMappedSearch) => {
  const query = {
    ...filtersQuery,
    [name]: { value, type: 'filter' }
  }

  const path = buildPath(url, query, isMappedSearch)

  return `${window.env.baseHost}${path.pathname}${path.search}`
}

const OptionFilterItem = ({
  filterKey,
  name,
  query,
  optionLabel,
  quantity,
  selected,
  onFilterClick,
  filtersQuery,
  url,
  isMappedSearch,
  filterTypeIndex,
  filterElementIndex,
  rightSpacing
}) => {
  const onFilter = event => {
    event.preventDefault()
    event.stopPropagation()

    onFilterClick({
      name: filterKey,
      value: query.replace(/\s/g, '_'),
      type: 'filter',
      dataLayerOptions: {
        filter: 'Normal',
        filterType: { index: filterTypeIndex, value: name },
        filterElement: { index: filterElementIndex, value: optionLabel }
      }
    })
  }

  const { baseUrl } = useContext(EntryKeyContext)

  const SEOEntryKeyFilterPath = `/${baseUrl}/${filterKey}/${query.replace(/\s/g, '_')}`

  return (
    <S.CheckboxWrapper
      href={buildFilterPath(
        filterKey,
        query.replace(/\s/g, '_'),
        url,
        filtersQuery,
        isMappedSearch
      )}
      data-seo-entry-key-filter-path={SEOEntryKeyFilterPath}
      onClick={onFilter}
      rightSpacing={rightSpacing}
    >
      <Checkbox isChecked={selected}>
        <Text as="span" size="mega" noMargin>
          {optionLabel}{' '}
        </Text>
        <Text as="span" size="kilo" noMargin>
          ({quantity})
        </Text>
      </Checkbox>
    </S.CheckboxWrapper>
  )
}

OptionFilterItem.propTypes = {
  filterKey: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  query: PropTypes.string.isRequired,
  optionLabel: PropTypes.string.isRequired,
  quantity: PropTypes.number.isRequired,
  select: PropTypes.bool,
  onFilterClick: PropTypes.func.isRequired,
  filtersQuery: PropTypes.object,
  url: PropTypes.string,
  isMappedSearch: PropTypes.bool
}

export default OptionFilterItem
